function mgSlideUpDown() {
    if (document.querySelector('.parent-menu')) {
        try {
            /* forDropDown for any */
            const forDropDowns = function () {
                $('.parent-menu').on('click', function (e) {
                    $(this).next('.child-menu').slideToggle(300);
                    $(this).toggleClass('toggle-rotate');
                });
            };
            forDropDowns();
            /* for One forDropDown */
            const forDropDown = function () {
                $('.parent-down').on('click', function (e) {
                    $(this).next('.child-down').slideToggle(300);
                    $(this).toggleClass('toggle-rotate');
                });
            };
            forDropDown();
        } catch (err) {
        }
    }
}